/**
 * Network-idle tracker — counts in-flight axios requests.
 * Impression queue reads isNetworkIdle() before sending each impression
 * so analytics never contend with data API calls for the 6 browser
 * connection slots.
 *
 * Wire up in index.js via axios interceptors — see that file.
 * Impression fetches use native fetch (not axios) so they won't
 * increment this counter.
 */

let count = 0;

export function incrementRequests() {
  count++;
}

export function decrementRequests() {
  count = Math.max(0, count - 1);
}

export function isNetworkIdle() {
  return count === 0;
}
